var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height text-center",attrs:{"id":"error-view","tag":"section"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-img',{attrs:{"src":_vm.error,"width":"200%","height":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }